export const clothing = {
  state: {
    all: null,
    types: [],
  },
  mutations: {
    setClothingData(state, clothingData) {
      state.all = clothingData
    },
    setClothingTypes(state, types) {
      state.types = types.filter((type) => type !== 'object')
    },
  },
  actions: {
    setClothing(context, clothingData) {
      context.commit('setClothingData', clothingData)
    },
    setClothingTypes(context, types) {
      context.commit('setClothingTypes', types)
    },
  },
}
